module.exports = __webpack_public_path__ + "5d226c24f42dfb52c5447a1d13dc4867.png";